import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { getCookie } from "../utility/Cookie";

import "../styles/Pricing.css";

import CardPricing from "./layout/CardPricing";



const Pricing = () => {
  const [pricing, setPricing] = useState([]);
  const [loading, setLoading] = useState(true);

  const TOKEN = getCookie("_t_");

  const history = useHistory();

  const parseJwt = () => {
    let base64Url = getCookie("_t_").split(".")[1];
    let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    let jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  };

  const handleClickPayment = (e, id) => {
    e.preventDefault();

    if (!TOKEN) {
      alert("Please login first");
      return;
    } else {
      let data = {
        package_id: id,
        user_id: parseJwt().id,
      };
      fetch(`${process.env.REACT_APP_BASE_URL}/pay`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((data) => {
          console.log("data", data);
          history.push(`payment/${data.msg.payment_token}`);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/plans`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          const dataPricing = [...data.msg].map((ele) => {
            return {
              name: ele.name,
              list: ele.list,
              _id: ele._id,
              price: ele.price,
            };
          });
          setPricing(dataPricing);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return loading ? (
    <div style={{ width: "", textAlign: "center", marginTop: "300px" }}>
      <div className="lds-dual-ring"></div>
    </div>
  ) : (
    <section
      className="pricing-page"

    >
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="pricing-body">
              <div className="pricing-body-content">
                <div className="pricing-items">
                  {pricing.map((item, index) => (
                    <CardPricing
                      key={index}
                      item={item}
                      handleClickPayment={handleClickPayment}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
